/*
 * @Author: Wei Guojun 
 * @Date: 2021-04-14 10:04:28 
 * @Last Modified by: Wei Guojun
 * @Last Modified time: 2022-10-23 11:39:11
 */
<template>
  <div>
    <div class="headerNav">
      <div class="nav">
        <!-- <div class="title" @click="toPath(0)" :class="$store.state.seetIndex == 0 ? 'active' : ''">批量导入订单</div> -->
        <nav>
          <div
            :class="$store.state.seetIndex == index ? 'active' : ''"
            v-for="(item, index) in nav"
            :key="index"
            @click="toPath(index)"
          >
            {{ item.name}}
            <span v-if="index==1">{{$store.state.wrongNum || ''}}</span>
            <span v-if="index==2">{{$store.state.rightNum || ''}}</span>
          </div>
        </nav>
      </div>
    </div>
    <div class="export_box" v-if="$store.state.seetIndex == 0">
      <div class="export_title">
        <span>1</span>下载标准模板
      </div>  
      <div class="export_des">批量导入支持不同排版格式的订单文件，为了避免解析错误，建议使用标准模板；</div>
      <div class="download_file">
        <el-button type="primary" size="small" @click="downloadfile"><i class="el-icon-download"></i>点击下载标准模板</el-button>
      </div>
      <div class="export_title">
        <span>2</span>选择寄件信息
      </div>  
      <div class="export_des">批量订单默认为同一个寄件人，请选择寄件人信息。</div>
      <div class="export_send_person">
        <div class="title"><span style="color:red;padding-right:4px">*</span>选择寄件人</div>
        <el-input placeholder="请选择寄件地址" v-model="sendAddress" readonly>
          <el-button type="primary" slot="append" @click="dialog=true">选择</el-button>
        </el-input>
      </div>
      <div class="export_title">
        <span>3</span>上传订单文件
      </div>  
      <div class="export_des">单次最多支持智能解析{{limitNum}}条；</div>
      <div class="export_upload_box">
        <el-upload
            style="width:700px"
            v-loading="isUp"
            action=''
            ref="excel-upload-input"
            class="upload-demo"
            :multiple = false
            drag
            accept=".xlsx, .xls"
            :before-upload="beforeUpload"
            :http-request="uploadAction"
            >
            <div class="uploadBox">
              <img src="../assets/images/fileAdd.png" />
            </div>
            <div class="el-upload__text">直接将文件拖拽至虚线区域，或点击+上传</div>
        </el-upload>        
      </div>
    </div>
    <errorSheet v-else-if="$store.state.seetIndex == 1" ref="errorSheet"></errorSheet>
    <normalSheet v-else ref="normalSheet"></normalSheet>
    <div v-if="dialog">
      <el-dialog
        center
        top="50px"
        width="1000px"
        title="选择寄件人"
        :visible.sync="dialog"
        @close="closeDialog"
      >
        <div style="height:580px">
          <v-send-address ref="sendList"></v-send-address>
        </div>
      </el-dialog>
    </div>
  </div>  
</template>
<script>
import util from "@/util/util";
import home from "@/api/home";
import errorSheet from './errorSheet';
import normalSheet from './normalSheet';
import vSendAddress from '@/components/send_address.vue'
export default {
    name:'sheet',
    data(){
        return{
           nav:[
             {name:'批量导入订单',path:'',count:0},
             {name:'异常信息订单',path:'',count:0},
             {name:'正常信息订单',path:'',count:0},
           ],
           downloadFileUrl:'',
           isUp:false,
           addressId:false,
           limitNum:0,
           sendAddress:'',
           dialog:false
        }
    },
    components:{
      errorSheet,
      normalSheet,
      vSendAddress,
    },
    created() {
      this.downloadFileUrl = util.getJsonValues(this.$store.state.commondict,'orderexcel')||'https://ydgj.ydpei.com/file/downloadExcelForParcel'  
      this.limitNum = util.getJsonValues(this.$store.state.commondict,'excelmaxline') || 200
    },
    mounted() {
      console.log('模板')
      this.getmorenAddress()  
    },

    methods: {
      /**关闭对应的Dialog */
      closeDialog() {
        this.dialog = false
      },      
      /** 获取默认寄件地址 */
      getmorenAddress() {
        home.getDefaultAddress(this).then((res) => {
          if (res.success) {
            const data = res.data
            if(data){
              this.addressId = data.id;
              this.sendAddress = (data.id ? '(默认)':'')
              data.name+' '+
              data.phone+' '+
              data.province_name + 
              data.city_name+
              data.district_name+
              data.address
            }else{
              this.sendAddress = ''
              this.addressId = false
            }
          }
        })
      },
      //函数声明
      toPath(index) {
        this.$store.state.seetIndex = index;
      },
      //上传之前
      beforeUpload(file){
        if(!this.sendAddress){
          this.$message.error("请先选择寄件人信息！");
          return false;
        }
        this.files = file;
        this.isUp = true;
        let fileSize=file.size/1024
        if(fileSize>1024){
          this.$message.error("您上传的文件大小超过1MB，请调整后重新上传！");
          this.isUp=false;
          return false;
        }
        return true;
      },
      //上传动作
      uploadAction() {
        let formData = new FormData();
        formData.append("account_id", util.getCookie("account_id"));
        formData.append("file", this.files);
        formData.append("default_address_id",this.addressId)
        home.upLoadFile(this,formData,"/file/uploadExcelForOrder").then(res => {
          if (res.success) {
            const wrongNum = res.data.wrong_num;
            const correctNum = res.data.right_num;
            if(wrongNum<=0 && correctNum<=0){
              this.$message.error(
                "您上传的文件数据为空，请填写数据并保存文件后在试？"
              );
              return;
            }
            this.$store.state.sheetNum = [wrongNum,correctNum];
            if(wrongNum == 0){
              this.$store.state.seetIndex = 2;
              this.$nextTick(()=>{
                this.$refs.normalSheet.loadData();
                this.$refs.normalSheet.rowBgcolor = [];
                this.$refs.normalSheet.parcel_id_list = [];
                this.$store.state.mgcColorRow = [];
              })
            }else{
              this.$store.state.seetIndex = 1;
              this.$nextTick(()=>{
                this.$refs.errorSheet.loadData();
              })
            }
            this.$message.success('上传成功!')
            this.isUp = false;
          } else {
            this.$message.error("上传失败!");
          }
        }).finally(()=>{this.isUp = false;})
      },
      //弹窗展示
      downloadfile(){
        let a=document.createElement('a')
        a.setAttribute("id",'export_file_ysb');
        a.style.display='none'  
        a.href=this.downloadFileUrl 
        document.body.appendChild(a)
        a.click() 
        document.body.removeChild(document.getElementById("export_file_ysb"));
      }
    }
}
</script>
<style lang="stylus" scoped>
.headerNav {
  height: 40px;
  font-size: 14px;
  background: #f5f5f5;
  border-radius: 3px;
  font-weight: bold;
  nav {
    float: left;
    color: #737373;

    >div {
      float: left;
      height: 40px;
      line-height: 40px;
      margin-left: 20px;
      cursor: pointer;
      position: relative;

      &::after {
        position: absolute;
        background: #ffffff;
        content: '';
        left: 0;
        bottom: 0;
        height: 1px;
        width: 100%;
      }
      >div:nth-child(1){
        &::before {
          content: ' ';
          height: 20px;
          width: 2px;
          background: #212121;
          position: absolute;
          right: 0;
          top: 50%;
          margin-top: -10px;
        }
      }
    }

    .active {
      color: #1C8BF6;
      animation: font-color-am 0.3s ease-in 1;

      &::after {
        background: #1C8BF6;
        animation: border-bottom 0.3s ease-in 1;
      }
    }

    @keyframes border-bottom {
      0% {
        left: 50%;
        width: 0;
      }

      100% {
        left: 0;
        width: 100%;
      }
    }

    @keyframes font-color-am {
      0% {
        color: #737373;
      }

      100% {
        color: #1C8BF6;
      }
    }
  }
}
.export_box{
  padding-left: 30px;
  padding-top: 30px;
  .export_title{
    font-size: 16px
    color: #222222;
    font-weight: bold;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    span{
        display: inline-block;
        color: #2ea2fc;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 2px solid #2ea2fc;
        text-align: center;
        line-height: 20px;
        margin-right: 10px;
    }
  }  
  .export_des{
    color: #909399;
    font-size: 12px;
    padding-left: 36px
    line-height: 30px;
  }
  .export_send_person{
    display: flex;
    justify-content: flex-start;
    width: 700px;
    font-size: 14px;
    font-weight: 500;
    flex-direction: row;
    align-items: center;
    margin:10px 0 20px 0;
    .title{
      padding-left: 36px;
      width: 110px;
    }
    /deep/.el-input-group__append {
      background-color: #409EFF;
      color:#fff;
    }
  }
  .download_file{
    padding-left: 36px;
    margin: 10px 0 20px 0;
  }
  .export_upload_box{
    padding-left: 36px;
    margin-top: 10px;
    /deep/ .el-upload-dragger{
      width: 666px;
    }
    .uploadBox {
      width: 60px;
      height: 60px;
      display: flex;
      border: 2px dashed #d9d9d9;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 30px auto;
    }
    .el-upload__text{
      color: rgba(144,147,153,1);
      font-size: 12px;
    }
  }
}
</style>
